import styled, { css } from 'styled-components';
import { body2Bold, spacing } from 'ui/theme';

export const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};
  overflow-anchor: none;
`;

export const CombinatorWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${spacing.half};
  background: transparent;
`;

export const Combinator = styled.div`
  align-items: center;
  column-gap: ${spacing.half};
  display: flex;
  flex: 1 1 auto;
`;

export const Toolbar = styled.div`
  &:last-child:nth-child(n+2) {
    > * > * > button  {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
  }
`;

export const TextWrapper = styled.div`
  ${body2Bold};
`;

export const actionButtonGroupRadii = (selectorPrefix = '> * >') => css`
 ${selectorPrefix}:first-child:nth-last-child(n+2) > button {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  ${selectorPrefix}:not(:first-child):not(:last-child):nth-last-child(n+2) > button {
    border-radius: 0;
  }
  ${selectorPrefix}:last-child:nth-child(n+2) > button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
`;

export const ActionButtonWrapper = styled.div`
  display: flex;
  ${actionButtonGroupRadii('>')};
`;
